export default {
  className: 'brandSpecial',
  fields: [
    {
      name: 'category',
      validators: [
        (val) => val ? null : '所属分类不可为空'
      ]
    },
    {
      name: 'brandTitle',
      tooltip: '请简要输入标题',
      validators: [
        (val) => val ? null : '标题不可为空'
      ]
    },
    {
      name: 'explanation',
      tooltip: '请简要输入说明，说明文字长度不能超过6个字符',
      validators: [
        (val) => {
          if (!val) { return null }
          return val.length <= 6 ? null : '说明文字长度超出'
        }
      ]
    },
    {
      name: 'image',
      tooltip: '建议750px * 400px',
      validators: [
        (val) => val ? null : '主题图片不可为空'
      ]
    },
    {
      name: 'bgColor',
      validators: [
        (val) => val ? null : '主题背景颜色不可为空'
      ],
      tooltip: '主题背景颜色搭配主题图片设置，须和主题图片保持一致'
    }
  ],
  search: [
  ],
  action: {
    delete: false,
    create: false
  }
}
